// src/functions/fetchUserQuestions.js
export async function fetchUserQuestions({ userId, token, themeName, questionIds }) {
  const body = {
    userId,
    themeName: themeName || 'health-sprint',
  };
  if (Array.isArray(questionIds)) {
    body.questionIds = questionIds;
  }

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getUserQuestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to fetch user questions');
  }
  return resp.json();
}
